// extracted by mini-css-extract-plugin
export default {"pdfContainer":"pdfDocument_pdfContainer__TayKf","pdfDocument":"pdfDocument_pdfDocument__9UbU7","pdfPage":"pdfDocument_pdfPage__w9OW9"};